// Copyright ©️ 2026 eVolve MEP, LLC

import { ActiveAllSelect, type ActiveAllFilter } from 'components/Mantine/GlobalFilters/ActiveAllSelect';
import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { isNil } from 'helpers/isNotNil';

export const ActiveAllSelectFilter = ({ filter, value, onChange }: GlobalFilterProps<'activeAll'>) => {
  if (isNil(filter)) return null;

  const setActiveAll = (state: ActiveAllFilter) => {
    onChange({
      key: filter.key,
      state,
      value: (state === 'active' ? filter.whenActive : filter.allPossible) ?? undefined,
    });
  };

  return <ActiveAllSelect value={value.state} onChange={setActiveAll} dataLabel={filter.key} />;
};
